export default class Pagination {
  public page: number = 0;
  public itemsPerPage: number = 0;
  public sortBy: Array<string> = [];
  public sortDesc: Array<boolean> = [];
  public pageStart: number = 0;
  public pageStop: number = 0;
  public itemsLength: number = 0;

  constructor(page: number, itemsPerPage: number) {
    this.page = page;
    this.itemsPerPage = itemsPerPage;
  }
}
